$(function () {

    'use strict';

    const timePeriods = RivalIQ.state.timePeriods;

    const config = {
        page: RivalIQ.configuration.menus.getConfiguration().ACCOUNT_SETTINGS,
        app: RivalIQ.apps.AccountSettings,
        options: {
            churnReasons: window.churnReasons
        },
        components: {
            companySets: {
                disabled: true
            },
            timePeriod: timePeriods.getDefinitionByType(timePeriods.types.NOT_AVAILABLE)
        }
    };

    RivalIQ.apps.Shell.execute('show:app', config);
});
